module.exports = __webpack_public_path__ + "static/img/news77_4.4e998d4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news77/news77_4.webp
// module id = aAVP
// module chunks = 0